import script from "./MethodologyView.vue?vue&type=script&setup=true&lang=js"
export * from "./MethodologyView.vue?vue&type=script&setup=true&lang=js"

import "./MethodologyView.vue?vue&type=style&index=0&id=267317b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-267317b4"]])

export default __exports__